/**
 * Preferences-related Redux Actions
 */
/* tslint:disable:max-line-length */
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Preferences');

export const setLanguage = actionCreator<{ language: AvailableLanguages }>('SET_PREFERRED_LANGUAGE');

// Request Async Actions
export const requestSetPreferencesFromLocalStorage = actionCreator('REQUEST_SET_PREFERENCES_FROM_LOCAL_STORAGE');

// Async Actions
export const setPreferencesFromLocalStorage = actionCreator.async<void, IPreferencesState>('SET_PREFERENCES_FROM_LOCAL_STORAGE');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/preferences.ts